import { render, staticRenderFns } from "./input-form-penilaian.vue?vue&type=template&id=38465dc5&"
import script from "./input-form-penilaian.vue?vue&type=script&lang=js&"
export * from "./input-form-penilaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports